module.exports = "/images/Oman.png?a0fd136c8dc8c18f2634bfba23101458";